<template>
  <div class>
    <div class="products-container">
      <div class="container">
        <hometitle :title="productsTitle" :subtitle="productsSubTitle" >
          <div class="products-nav col-9 col-md-7">
            <div class="products-nav-box d-flex flex-wrap justify-content-md-end justify-content-start">
              <a
                class="products-nav-items"
                v-on:click="change(index)"
                :class='currentIndex==index?"nav-items-active":""'
                v-for="(nav, index) in productsData"
                :key="index"
                href="javascript:;"
              >{{nav.name}}</a>
              <router-link v-if="currentLanguage == 'CN'" tag="a" class="products-nav-items nav-more" to='/products'>更多>></router-link>
              <router-link v-else-if="currentLanguage == 'EN'" tag="a" class="products-nav-items nav-more" to='/products'>more>></router-link>
              <router-link v-else-if="currentLanguage == 'JP'" tag="a" class="products-nav-items nav-more" to='/products'>もっと見る>></router-link>
            </div>
          </div>
          
        </hometitle>
        <div
          class="row"
          :class='currentIndex==index?"":"d-none"'
          v-for="(item, index) in productsData"
          :key="index" >
          <div class="col-6 col-md-3 products-items" v-for="(data, index) in item.productsList.slice(0,8)" :key="index">
            <router-link tag="a" :to="`/productscontent/${data._id}`" class="products-link" href="javascript:;">
              <div class="products-img">
                <img :src="data.image[0].url" :alt="data.name" />
              </div>
              <div class="products-text">
                <p class="products-text-name">{{ data.name }}</p>
                <p class="products-text-model">{{ data.number }}</p>
              </div>
            </router-link>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import HoemTitle from '../components/HomeTitle'
import productslistCN from '../data/CN/productslist_CN.json'
import productslistEN from '../data/EN/productslist_EN.json'
import productslistJP from '../data/JP/productslist_JP.json'
export default {
  data() {
    return {
      currentIndex: 0,
      currentLanguage: '', // 当前语言
      productsTitle: '产品中心',
      productsSubTitle: 'Products',
      productsData: []
    }
  },
  mounted() {
    const _this = this
    window.addEventListener('setItemEvent', function(e) {
        // e.key : 是值发生变化的key
        // 例如 e.key==="token";
        // e.newValue : 是可以对应的新值
        if (e.key === 'language') {
            _this.currentLanguage = e.newValue
            var language = e.newValue
            if (language === 'CN') {
              _this.productsData = productslistCN
            } else if (language === 'EN') {
              _this.productsData = productslistEN
            } else if (language === 'JP') {
              _this.productsData = productslistJP
            }
        }
    })
  },
  methods: {
    change: function(index) {
      // 在这里实现选项卡切换操作：本质就是操作类名
      // 如何操作类名？就是通过currentIndex
      this.currentIndex = index
    },
    // 查询所有的产品
    findProductsData: function() {
      var language = localStorage.getItem('language')
      this.currentLanguage = language
      if (language === 'CN') {
        this.productsData = productslistCN
      } else if (language === 'EN') {
        this.productsData = productslistEN
      } else if (language === 'JP') {
        this.productsData = productslistJP
      }
      
    }
  },
  created() {
    this.findProductsData()
    
  },
  components: {
    hometitle: HoemTitle
  }
}
</script>
<style scoped>
.products-nav-items:hover {
  background-color: #048bd4;
  color: #fff;
}

.nav-more {
  color: #f15500;
}

.nav-items-active {
  background-color: #048bd4;
  color: #fff;
}
@media (max-width: 768px) {
  .products-items {
    margin-top: 20px;
  }
  .products-nav {
    margin-top: 20px;
  }
  .products-img {
    height: 224px !important;
  }
  .products-nav-box a {
    margin-bottom: 10px;
  }
}

.products-container {
  padding-top: 50px;
  padding-bottom: 40px;
}

.products-link {
  display: block;
  border: 1px solid #e8e8e8;
  transition: border 0.3s ease;
  transition: box-shadow 0.3s ease;
  margin-bottom: 40px;
}

.products-link:hover {
  border-color: #048bd4;
  color: #fff;
  box-shadow: 0 4px 10px rgba(0, 0, 0, 0.2) !important;
}

.products-link:hover .products-text-model {
  color: #fff;
}

.products-link:hover .products-text {
  background-color: #048bd4;
}
.products-link:hover .products-img img {
  transform: scale(1.1);
}

.products-img {
  overflow: hidden;
  text-align: center;
  height: 311px;
  /* padding: 20px 30px; */
}
.products-img img {
  width: 100%;
  transition: all 0.3s ease;
}
.products-text {
  text-align: center;
  padding: 10px;
  background-color: #e8e8e8;
  transition: background 0.3s ease;
}

.products-text-name {
  font-size: 14px;
  line-height: 24px;
}
.products-text-model {
  font-size: 12px;
  color: #666;
}
</style>